<template>
  <div class="flex w-full justify-evenly">
    <div class="w-full" v-for="(option, index) in options" :key="index">
      <input
        type="radio"
        :placeholder="computedPlaceholder"
        v-model="inputValue"
        :required="required"
        :value="option.value"
        @change="$emit('update-value', inputValue)"
        :name="uuid"
        :id="uuid + '' + index"
        :class="{ required: required, 'border-primary-500': inputValue }"
        :disabled="disabled"
      />
      <label class="block text-black tracking-wide text-sm" :for="uuid + '' + index">
        <span>{{ option.text }}</span>
      </label>
    </div>
  </div>
</template>

<script>
const Validation = require("@/modules/input/components/Validation.vue").default;
const InputBase = require("@/modules/input/components/InputBase.vue").default;

export default {
  name: "InputRadio",
  data() {
    return {
      uuid: this.generateUuid()
    };
  },
  extends: InputBase,
  props: {
    options: {
      type: Array,
      required: true
    },
    value: {
      type: String
    }
  },
  components: {},
  methods: {},
  computed: {},
  created() {
    if (this.required) {
      this.validations.unshift({ validation: "required" });
    }
  },
  watch: {
    value: {
      handler(Val) {
        this.inputValue = Val;
      },
      immediate: true
    }
  }
};
</script>

<style scoped>
input {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border: none;
  border-radius: 0;
  font-size: 1em;
  width: 100%;
}

/* graceful degradation for ie8 */
input[type="radio"] {
  width: auto;
  float: left;
  margin-right: 0.75em;
  background: transparent;
  border: none;
}

input[type="radio"]:checked,
input[type="radio"]:not(:checked) {
  background: transparent;
  position: relative;
  visibility: hidden;
  margin: 0;
  padding: 0;
}

input[type="radio"] + label {
  cursor: pointer;
}

input[type="radio"]:checked + label::before,
input[type="radio"]:not(:checked) + label::before {
  content: " ";
  display: inline-block;
  width: 17px;
  height: 17px;
  position: relative;
  top: 4px;
  border: 1px solid #bbb;
  background: white;
  margin-right: 0.6em;
  box-shadow: inset 0 1px 1px 0 rgba(0, 0, 0, 0.1);
}

input[type="radio"]:checked + label::before,
input[type="radio"]:not(:checked) + label::before {
  border-radius: 30px;
}

input[type="radio"]:hover + label::before {
  background: #ddd;
}

input[type="radio"]:checked + label::before {
  background: #ebd175;
  border-color: #ebd175;
}
</style>
